import * as R from 'ramda'
import querystring from 'querystring'

export function getSearchQuery(location) {
  return querystring.parse(R.drop(1, location.search))
}
